import { render, staticRenderFns } from "./create.vue?vue&type=template&id=2e661850&scoped=true&"
import script from "./create.vue?vue&type=script&lang=js&"
export * from "./create.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e661850",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/wangmin/Projects/devidia_projects/devidia-p1-web-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2e661850')) {
      api.createRecord('2e661850', component.options)
    } else {
      api.reload('2e661850', component.options)
    }
    module.hot.accept("./create.vue?vue&type=template&id=2e661850&scoped=true&", function () {
      api.rerender('2e661850', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/incomingInspectionMgr/nskTemplateMgr/create.vue"
export default component.exports